import {
	DocumentModel,
	DocumentServiceFactory,
	EntityInstancePath,
	GroupInstance
} from "@com.mgmtp.a12.kernel/kernel-md-facade";

import { isGroupInstanceArray } from "./documentHelpers";
import { getDocumentModelElement } from "./modelElementHelper";

const documentService = new DocumentServiceFactory().getDocumentService();

/**
 * Checks if the max repeatability inside of a repeat is reached
 * @param path the path to the repeat
 * @param documentModel
 * @param document
 */
export const maxRepeatabilityReached = (
	path: EntityInstancePath,
	documentModel: DocumentModel,
	document: GroupInstance
) => {
	const documentModelElement = getDocumentModelElement(documentModel, path);

	if (!documentModelElement) {
		return true;
	}

	const repeatData = documentService.getAssignedObject(document, path) as GroupInstance[];

	return (
		isGroupInstanceArray(repeatData) &&
		documentModelElement.type === "Group" &&
		repeatData.length >= documentModelElement.repeatability
	);
};
